export default class LicenseActivity {
  userId: string = undefined;
  acceptedOn: string = undefined;
  licenseActivityType: string = undefined;
  productType: string = undefined;
  variantType: string = undefined;
  name: string = undefined;
}
